const postServiceTypes = {
  toastr: 'Tipo de Servicio agregado',
  toastr1: ' fue agregado con éxito',
  toastrError: 'Tipo de Servicio ya registrado',
  toastrError1: 'Ingrese otro nombre'
}

export default postServiceTypes;
